import React from 'react';
import { Icon } from '../../assets/icons/Icon.jsx';

/** Floating dark toast pill. Wanted toasts sit on inverse-background. */
export function Toast({ children, icon, action, style }) {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '12px 16px',
        borderRadius: 'var(--radius-md)',
        background: 'var(--inverse-background)',
        color: 'var(--inverse-label)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--font-size-body-2)',
        lineHeight: 'var(--line-height-body-2)',
        boxShadow: 'var(--shadow-overlay)',
        maxWidth: 480,
        ...style,
      }}
    >
      {icon && <Icon name={icon} size={20} style={{ flex: 'none' }} />}
      <span style={{ flex: 1 }}>{children}</span>
      {action && <span style={{ flex: 'none', color: 'var(--primary-normal)', fontWeight: 600, cursor: 'pointer' }}>{action}</span>}
    </div>
  );
}

export default Toast;
